import axios from "axios";
import { IEvent } from "../../interfaces";
import requestConfig from "./config";
import configs from "../../configs";

const BASE_URL = configs.api.baseUrl as string;

class EventAPI {
	static createEvent(eventData: IEvent): Promise<IEvent> {
		return axios.post(`${BASE_URL}/admin/event/`, eventData, requestConfig);
	}

	static getEvent(eventId: string): Promise<IEvent> {
		return axios.get(`${BASE_URL}/admin/event/${eventId}`);
	}

	static getEvents(): Promise<IEvent[]> {
		return axios.get(`${BASE_URL}/admin/event/`, requestConfig);
	}

	static getDeletedEvents(): Promise<IEvent[]> {
		return axios.get(`${BASE_URL}/admin/event/delete/`, requestConfig);
	}

	static updateEvent(eventId: string, data: FormData): Promise<IEvent> {
		return axios.put(`${BASE_URL}/admin/event/${eventId}`, data, requestConfig);
	}

	static deleteEvent(eventId: string): Promise<IEvent> {
		return axios.put(`${BASE_URL}/admin/event/delete/${eventId}`, null, requestConfig);
	}

	static recoverDeletedEvent(eventId: string): Promise<IEvent> {
		return axios.put(`${BASE_URL}/admin/event/recover/${eventId}`, null, requestConfig);
	}

	static deleteEventPermanently(eventId: string): Promise<IEvent> {
		return axios.delete(`${BASE_URL}/admin/event/permanentdelete/${eventId}`, requestConfig);
	}
}

export default EventAPI;
